import React from 'react';

const Loader = ({ domain }) => {
  return (
    <div className="centered active">
      <div className="progress-bar">
        <div className="progress-fill"></div>
      </div>
      <div style={{ marginBottom: '12px', fontSize: '15px', fontWeight: '500' }}>
        loading <span className="dynamic-domain">{domain}</span> mail settings ...
      </div>
      <div className="info">
        <i className="far fa-calendar-alt"></i> Loading...
      </div>
    </div>
  );
};

export default Loader;